import { useNavigate } from "react-router-dom";
import useAppMode, { SEEKER, RECRUITER } from "../../mode/useAppMode";

/**
 * Switches the dashboard a person lands on. Only rendered for people who
 * administer at least one employer.
 */
export default function ModeSwitch() {
  const [mode, setMode] = useAppMode();
  const navigate = useNavigate();

  function pick(next) {
    if (next === mode) return;
    setMode(next);
    navigate(next === RECRUITER ? "/recruiter" : "/dashboard");
  }

  return (
    <div className="modeSwitch" role="group" aria-label="Dashboard mode">
      <button
        type="button"
        className={mode === SEEKER ? "active" : undefined}
        aria-pressed={mode === SEEKER}
        onClick={() => pick(SEEKER)}
      >
        Seeking
      </button>
      <button
        type="button"
        className={mode === RECRUITER ? "active" : undefined}
        aria-pressed={mode === RECRUITER}
        onClick={() => pick(RECRUITER)}
      >
        Hiring
      </button>
    </div>
  );
}
